/**
 * Priority map for all notification types.
 * Lower number = higher priority.
 */
export const NOTIFICATION_PRIORITIES: Record<string, number> = {
	//#region danger type notifications
	overpower: 1,
	overTemperature: 2,
	overtemp: 3,
	overvoltage: 4,
	overcurrent: 5,
	undervoltage: 6,
	'cal_abort:overpower': 7,
	highTemperature: 8,
	high_temperature: 9,
	low_temperature: 10,
	mount_error: 11,
	cableUnplugged: 12,
	calibration_error: 13,
	ext_temp_missing: 14,
	lora_limit_reached: 15,
	obstruction: 16,
	safety_switch: 17,
	associateCloud: 18,
	humidityError: 19,
	temperatureError: 20,
	dali_control_gear_missing: 21,
	dali_gear: 22,
	criticalBattery: 23,
	data_error: 24,
	'bad_feedback:rotating_in_wrong_direction': 25,
	'bad_feedback:both_directions_active': 26,
	'bad_feedback:failed_to_halt': 27,
	//#endregion danger type notifications

	'cal_abort:timeout_open': 28,
	'cal_abort:timeout_close': 29,
	'cal_abort:implausible_time_to_fully_open': 30,
	'cal_abort:implausible_time_to_fully_close': 31,
	'cal_abort:implausible_time_to_fully_open_w_steps': 32,
	'cal_abort:implausible_time_to_fully_close_w_steps': 33,
	'cal_abort:safety': 34,
	'cal_abort:ext_command': 35,
	'cal_abort:bad_feedback': 36,
	'cal_abort:implausible_power_consumption_in_close_dir': 37,
	'cal_abort:implausible_power_consumption_in_open_dir': 38,
	'cal_abort:implausible_step_duration_in_close_dir': 39,
	'cal_abort:too_many_steps_to_close': 40,
	'cal_abort:too_few_steps_to_close': 41,
	'cal_abort:implausible_step_duration_in_open_dir': 42,
	'cal_abort:too_many_steps_to_open': 43,
	'cal_abort:too_few_steps_to_open': 44,
	'cal_abort:interrupted': 45,
	'cal_abort:power_read': 46,
	'cal_abort:no_load': 47,
	'cal_abort:non_dimmable': 48,
	'cal_abort:unsupported_load': 49,
	'cal_abort:no_synchro': 50,
	weakSignal: 51,
	rebootRequired: 52,
	bleDisabled: 53,
	gatewayReportOlderThanDay: 54,
	// promoAlert: 55,
	// promoBlu: 56,
	// promoBluComing: 57,
	ai_is_completed: 58,
	ai_fail_reason_lower_consumption: 59,
	ai_fail_reason_higher_consumption: 60,
	ai_fail_reason_longer_sequence: 61,
	ai_fail_reason_shorter_sequence: 62,
	lowBattery: 63,
	bluLowBattery: 64,
	batteryError: 65,
	loqedWarning: 66,
	lora_duty_cycle_limit: 67,
	faulty_temperature_sensor: 68,
	low_pressure: 69,
	high_pressure: 70,
	faulty_pressure_sensor: 71,
	low_flow_rate: 72,
	high_flow_rate: 73,
	faulty_flow_rate_sensor: 74,
	// Vial fault notifications
	vial_fault_left_expired: 75,
	vial_fault_right_expired: 76,
	vial_fault_left_non_genuine: 77,
	vial_fault_right_non_genuine: 78,
	vial_fault_left_tag_error: 79,
	vial_fault_right_tag_error: 80,
	vial_fault_left_empty: 81,
	vial_fault_right_empty: 82,
	default: 1000,
};
